var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "nodalBlock" }, [
    _c("p", [_vm._v(_vm._s(_vm.pairedRecord.message))]),
    _vm._v(" "),
    _c("p", { staticClass: "text-muted text-right" }, [
      _vm._v(_vm._s(_vm.printDate(_vm.pairedRecord.date))),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.makePair.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [
              _vm._v("Комментарий к оплате"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.comment,
                  expression: "comment",
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                required: "",
                placeholder: "детали оплаты",
              },
              domProps: { value: _vm.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.comment = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("UploadImages", { ref: "images" }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Привязать оплату",
                  className: "btn btn-success",
                  type: "submit",
                  onClick: () => {},
                  loading: _vm.loading,
                  color: "white",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }